// src/App.jsx
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Deposits from "./pages/Deposits";
import KycList from "./pages/KycList";
import Users from "./pages/User/Users";
import Profile from "./pages/settings/Profile";
import AddUser from "./pages/User/AddUser";
import ViewPackages from "./pages/WebsiteSettings/ViewPackage";
import AddPackage from './pages/WebsiteSettings/addPackage';
import AddTelegramPackage from './pages/WebsiteSettings/addTelegramPackage';
import Logo from './pages/WebsiteSettings/logo';
import LegalPages from './pages/WebsiteSettings/legalPages';
import Logs from './pages/logs';
import AddProfit from "./pages/Profits/AddProfit";
import ViewProfit from "./pages/Profits/ViewProfit";
import FooterSettings from "./pages/WebsiteSettings/footer";
import AddFAQCategory from "./pages/WebsiteSettings/addFAQCategory";
import AddFaq from "./pages/WebsiteSettings/addFaq";
import ViewFaq from "./pages/WebsiteSettings/viewFaq";
import AddTestimonial from "./pages/WebsiteSettings/addTestimonial";
import ViewTestimonials from "./pages/WebsiteSettings/viewTestiomnials";
import GeneralSettings from "./pages/WebsiteSettings/general";
import Withdrawals from "./pages/withdrawals";
import AddBlogCategory from "./pages/WebsiteSettings/addBlogCategory";
import AddBlog from "./pages/WebsiteSettings/addBlog";
import ViewBlogs from "./pages/WebsiteSettings/viewBlog";
import Banners from "./pages/WebsiteSettings/Banners";
import Referrals from "./pages/Referrals";
import AdminGreetingsForm from "./pages/WebsiteSettings/addGreeetings";
export default function App() {
  const location = useLocation();
  const isLogin = location.pathname === "/login";

  // If you ever add other public pages (e.g. /forgot-password) extend the logic:
  // const isAuthLess = ["/login", "/forgot-password"].includes(location.pathname);

  if (isLogin) {
    // Render login standalone without the admin chrome
    return (
      <Box>
        <CssBaseline />
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* if you want, redirect root to /login when not authenticated */}
        </Routes>
      </Box>
    );
  }

  // Admin layout for all other routes
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Header />
        <Routes>
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/deposits" element={<ProtectedRoute><Deposits /></ProtectedRoute>} />
          <Route path="/referrals" element={<ProtectedRoute><Referrals/></ProtectedRoute>}/>
          <Route path="/kyc" element={<ProtectedRoute><KycList /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
          <Route path="/settings/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/users/add" element={<ProtectedRoute><AddUser /></ProtectedRoute>}/>
          <Route path="/website-settings/packages" element={<ProtectedRoute><ViewPackages /></ProtectedRoute>}/>
          <Route path="/website-settings/packages/add" element={<ProtectedRoute><AddPackage/></ProtectedRoute>}/>
          <Route path="/website-settings/telegram-packages/add" element={<ProtectedRoute><AddTelegramPackage/></ProtectedRoute>}/>
          <Route path="/website-settings/logos" element={<ProtectedRoute><Logo/></ProtectedRoute>}/>
          <Route path="/website-settings/legal-pages" element={<ProtectedRoute><LegalPages/></ProtectedRoute>}/>
          <Route path="/website-settings/footer-settings" element={<ProtectedRoute><FooterSettings/></ProtectedRoute>}/>
          <Route path="/website-settings/faq/categories/add" element={<ProtectedRoute><AddFAQCategory/></ProtectedRoute>}/>
          <Route path="/website-settings/faq/add" element={<ProtectedRoute><AddFaq/></ProtectedRoute>}/>
          <Route path="/website-settings/faq" element={<ProtectedRoute><ViewFaq/></ProtectedRoute>}/>
          <Route path="/website-settings/testimonial/add" element={<ProtectedRoute><AddTestimonial/></ProtectedRoute>}/>
          <Route path="/website-settings/testimonials" element={<ProtectedRoute><ViewTestimonials/></ProtectedRoute>}/>
          <Route path="/website-settings/general" element={<ProtectedRoute><GeneralSettings/></ProtectedRoute>}/>
          <Route path="/website-settings/festival-greetings" element={<ProtectedRoute><AdminGreetingsForm/></ProtectedRoute>}/>
          <Route path="/website-settings/blogs/categories/add" element={<ProtectedRoute><AddBlogCategory/></ProtectedRoute>}/>
          <Route path="/website-settings/blogs/add" element={<ProtectedRoute><AddBlog/></ProtectedRoute>}/>
          <Route path="/website-settings/blogs" element={<ProtectedRoute><ViewBlogs/></ProtectedRoute>}/>
          <Route path="/website-settings/banner" element={<ProtectedRoute><Banners/></ProtectedRoute>}/>
          <Route path="/withdrawals" element={<ProtectedRoute><Withdrawals/></ProtectedRoute>}/>
          <Route path="/logs" element={<ProtectedRoute><Logs/></ProtectedRoute>}/>
          <Route path="/profits/add" element={<ProtectedRoute><AddProfit/></ProtectedRoute>}/>
          <Route path="/profits" element={<ProtectedRoute><ViewProfit/></ProtectedRoute>}/>
          {/* fallback: redirect or 404 page */}
        </Routes>
      </Box>
    </Box>
  );
}
